import React, { Fragment } from "react";
import Box, { Item } from "devextreme-react/box";
import "./stops.scss";
import { faMapMarkerAlt, faGreaterThan } from '@fortawesome/pro-solid-svg-icons' //more icons at: https://fontawesome.com/icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ActionButton } from 'components'
import { useHistory } from 'react-router'

let dateFormat = require('dateformat')

export default ({ stops, loadNumber, useOdsVersion = false }) => {

    const history = useHistory();

    function setMoreDetailsVisible(stopId, odsStopEventId) {
        if (useOdsVersion) {
            history.push('/stop-details?odsStopEventId=' + (odsStopEventId || 0));
            return;
        }

        history.push('/stop-details?loadNumber=' + loadNumber + '&stopId=' + stopId);
    }

    return (
        <Fragment>
            {
                stops.map((stop, index) => (
                    <Box key={stop.stopId} width={"100%"} className="rect stops-our-color dividerline-margins stops-row ">
                        <Item ratio={1.25}>
                            <div className="center-icon">
                                {
                                    index === 0 ?
                                        <FontAwesomeIcon icon={faMapMarkerAlt} className={"stops-map-marker"} size={'2x'} />
                                        :
                                        <div className={"stops-event-text"}>
                                            {stop.stopEventType}
                                        </div>
                                }
                            </div>
                            {
                                (stop.orderType == "STC" || stop.orderType == "STCORC") ?
                                    <div className="center-icon">
                                        <div className={"stops-event-text red-component"}>
                                            {"STC"}
                                        </div>
                                    </div>
                                    :
                                    null
                            }
                            {
                                (stop.orderType == "CURETU") ?
                                    <div className="center-icon">
                                        <div className={"stops-event-text red-component"}>
                                            {"RTN"}
                                        </div>
                                    </div>
                                    :
                                    null
                            }
                        </Item>
                        <Item ratio={5}>
                            <div className={"stops-our-stops block stops-company-name"}>{stop.customerOrAddressName}</div>
                            <div className={"stops-our-stops block"}>{stop.addressOne}</div>
                            <div className={"stops-address"}>
                                <div className={"stops-our-stops block"}>{stop.city}, {stop.state} {stop.postalCode}</div>
                                <div className={"stops-mileage block"}>({stop.miles.toFixed(2)} miles)</div>                            
                            </div>
                            <div className={"stops-our-stops block stops-due-out"}>{(stop && stop.scheduledStartDate) && dateFormat(stop.scheduledStartDate, 'mm/dd - HH:MM')} {stop.appointmentTimeZone}</div>

                        </Item>
                        <Item ratio={.5}>
                            {
                                stop.displayStopDetails === false ?
                                    <div>

                                    </div>
                                    :
                                    <div className={"vertical-center right"}>
                                        <ActionButton buttonWidth={0} icon={faGreaterThan} buttonColor={"#11111100"} iconColor={"#0066A4"} onClick={() => setMoreDetailsVisible(stop.stopId, stop.odsStopEventId)} />
                                    </div >
                            }
                        </Item>
                    </Box>
                ))
            }
        </Fragment>
    );
};